import { selector } from "recoil"
import { unreadContactCountRequestIdState } from "src/recoil/atoms/bottomTab/unreadContactCountRequestIdState"
import { getUnreadContactCount } from "src/apis/bottomTab/getUnreadContactCount"
import { tokensState } from "src/recoil/atoms/authorization/tokensState"
import { accountIdState } from "src/recoil/atoms/account/accoutnIdState"
import { UnreadContactCountCacheService } from "src/services/cache/UnreadContactCountCacheService"

export const unreadContactCountSelector = selector({
  key: "selectors/bottomTab/unreadContactCountSelector",
  get: async ({ get }) => {
    get(unreadContactCountRequestIdState)
    const tokens = get(tokensState)
    const accessToken = tokens?.accessToken
    if (accessToken == null) {
      return
    }
    const accountId = get(accountIdState)
    if (accountId == null) {
      return
    }

    // キャッシュチェック
    const cached = UnreadContactCountCacheService.get()
    if (cached) {
      console.log("[UnreadContactCountSelector] Using cached unread count:", cached)
      return cached
    }

    // キャッシュが無い、または期限切れの場合はAPIから取得
    console.log("[UnreadContactCountSelector] Fetching from API")
    const result = await getUnreadContactCount({ accessToken, accountId })

    // キャッシュに保存
    if (result) {
      UnreadContactCountCacheService.set(result)
    }

    return result
  },
})
